<tsp-sidebar />

<tsp-navbar />

<div class="container-fluid container-main-nav">
	<router-outlet />
</div>

<tsp-toast aria-live="polite" aria-atomic="true" class="toast-container" />